// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import MemberBusinessAddressModel from '../../model/member-business-address-model';
import MemberBusinessAddressDTO from '../dto/member-business-address-dto';
import dtoSchema from '../schemas/member-business-address-schema';
import ContactAddressModel from '../../model/contact-address-model';

export default abstract class MemberBusinessAddressModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<MemberBusinessAddressDTO>) {
    super();
    if (data) {
      this.customerNumber = data.customerNumber ?? undefined;
      this.contactId = data.contactId ?? undefined;
      this.parentContactId = data.parentContactId ?? undefined;
      this.contactAccountId = data.contactAccountId ?? undefined;
      this.languageIso2 = data.languageIso2 ?? undefined;
      this.address = data.address ? ContactAddressModel.toModel(data.address) : undefined;
      this.isDifferentFromOwner = data.isDifferentFromOwner;
    }
  }
  /**
  * @type {int32}
  */
  customerNumber?: number;
  /**
  * @type {uuid}
  */
  contactId?: string;
  /**
  * @type {uuid}
  */
  parentContactId?: string;
  /**
  * @type {uuid}
  */
  contactAccountId?: string;
  /**
  */
  languageIso2?: string;
  /**
  */
  address?: ContactAddressModel;
  /**
  */
  isDifferentFromOwner?: boolean;

  static toModel(dto: DeepPartial<MemberBusinessAddressDTO>): MemberBusinessAddressModel;
  static toModel(dto: DeepPartial<MemberBusinessAddressDTO> | undefined | null): MemberBusinessAddressModel | undefined;
  static toModel(dto: DeepPartial<MemberBusinessAddressDTO> | undefined | null): MemberBusinessAddressModel | undefined {
    return dto ? new MemberBusinessAddressModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<MemberBusinessAddressModel> | MemberBusinessAddressModel): MemberBusinessAddressDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      customerNumber: unwrapped.customerNumber,
      contactId: unwrapped.contactId,
      parentContactId: unwrapped.parentContactId,
      contactAccountId: unwrapped.contactAccountId,
      languageIso2: unwrapped.languageIso2,
      address: unwrapped.address,
      isDifferentFromOwner: unwrapped.isDifferentFromOwner,
    } as MemberBusinessAddressDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for MemberBusinessAddressModel, can not map to MemberBusinessAddressDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
